// Auto-generated from InvitationStatusEnum

export const invitationStatus = {
  pending: 'pending',
  accepted: 'accepted',
  approved: 'approved',
  revoked: 'revoked',
  declined: 'declined',
}

export type TInvitationStatus = (typeof invitationStatus)[keyof typeof invitationStatus];
